import { inject, Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { AuthentificationType, LoginResponse, OidcSecurityService } from './oidc-security.service';
import { LoggerWrapper } from '../shared/providers/logger/logger-wrapper.service';
import { LoggerFactory } from '../shared/providers/logger/logger-factory.service';

const loginResponse: LoginResponse = {
  isAuthenticated: true,
  userData: {
    email: 'laurent-externe.stemmer@dalkia.fr',
  },
  accessToken: 'e6f2aaac-f862-4715-9ae9-82bdcf3a0c08',
  idToken: '697dbfa2-314c-4494-9c9d-c43219b7b09a',
};

@Injectable({ providedIn: 'root' })
export class MockOidcSecurityService implements OidcSecurityService {
  private logger: LoggerWrapper = inject(LoggerFactory).getInstance(this);

  redirectToAdfsLoginPage(_: AuthentificationType): void {
    this.logger.debug('[oidc] Mocked authorize');
  }

  checkAuth(_: AuthentificationType): Observable<LoginResponse> {
    this.logger.debug('[oidc] Mocked checkAuth');
    return of(loginResponse);
  }

  forceRefreshSession(_: AuthentificationType): Observable<LoginResponse> {
    this.logger.debug('[oidc] Mocked forceRefreshSession');
    return of(loginResponse);
  }

  clear(_: AuthentificationType): Observable<void> {
    this.logger.debug('[oidc] Mocked clear');
    return EMPTY;
  }

  getIdToken(_: AuthentificationType): Observable<string> {
    this.logger.debug('[oidc] Mocked getIdToken');
    return of(loginResponse.idToken);
  }

  getRedirectUrl(_: AuthentificationType): Observable<string> {
    this.logger.debug('[oidc] Mocked getRedirectUrl');
    return of('');
  }

  isOidcRequest(_: string): boolean {
    this.logger.debug('[oidc] Mocked getRedirectUrl');
    return false;
  }
}
